import * as types from '@/store/mutation-types';
import { PAGE_TYPES } from '@/constants';
import _ from 'lodash';

const state = {
  viewport: 'desktop',
  originalPage: {
    _id: null,
    blocks: [],
    droplet: null,
  },
  history: [],
  showHistory: false,
};

const getters = {
  history(state) {
    return state.history;
  },
  originalPage(state) {
    return state.originalPage;
  },
  viewport(state) {
    return state.viewport;
  },
  showHistory(state) {
    return state.showHistory;
  },
};

const mutations = {
  [types.SET_GLOBAL_VIEWPORT](state, p) {
    this._vm.$log.debug('SET_GLOBAL_VIEWPORT', p);
    state.viewport = p;
  },
  [types.SET_ORIGINAL_PAGE](state, p) {
    if (state.originalPage._id !== p.page._id) {
      state.originalPage._id = p.page._id;
      this._vm.$log.debug('SET_ORIGINAL_PAGE', p);
      let snapshot;
      if (PAGE_TYPES.includes(p.page.type)) {
        const data = _.cloneDeep(p.page.blocks);
        state.originalPage.blocks = data;
        snapshot = data;
      } else {
        const data = _.cloneDeep(p.page);
        state.originalPage.droplet = data;
        snapshot = data;
      }
      state.history = [{
        _id: 'initial-page-load',
        type: 'pageload',
        timestamp: new Date().toISOString(),
        meta: false,
        snapshot,
        counts: {
          pageForms: _.cloneDeep(p.page.forms),
          pageDraftForms: _.cloneDeep(p.page.draftForms),
          siteForms: _.cloneDeep(p.site.forms),
        },
      }];
    }
  },
  [types.ADD_TO_HISTORY](state, p) {
    this._vm.$log.debug('ADD_TO_HISTORY', p);
    state.history.splice(0, 0, {
      _id: p._id,
      type: p.type,
      timestamp: new Date().toISOString(),
      meta: p.meta,
      snapshot: _.cloneDeep(p.snapshot),
      counts: _.cloneDeep(p.counts),
    });
  },
  [types.TOGGLE_HISTORY](state, p) {
    state.showHistory = p;
  },
};

const actions = {
  setGlobalViewport({ commit }, p) {
    commit(types.SET_GLOBAL_VIEWPORT, p);
  },
  setOriginalPage({ commit, rootState }, p) {
    const site = rootState.Websites.currentSite;
    const payload = {
      page: p,
      site,
    };
    commit(types.SET_ORIGINAL_PAGE, payload);
  },
  addToHistory({ commit }, p) {
    commit(types.ADD_TO_HISTORY, p);
  },
  toggleHistory({ commit }, p) {
    commit(types.TOGGLE_HISTORY, p);
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/page/vuex.js